<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex
        xs12
        md6
        lg3
      >
        <v-toolbar color="secondary" dark >
          <v-toolbar-side-icon>
            <router-link to="/boxes"><v-icon>storage</v-icon></router-link>
          </v-toolbar-side-icon>
          <v-toolbar-title>{{$tc('app.box', 2)}}</v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-container>
            <v-layout row align-center d-inline-flex>
              <v-flex>
                <router-link to="/boxes">
                  <v-btn outline large fab color="green">
                    <v-icon>check</v-icon>
                  </v-btn>
                </router-link>
              </v-flex>
              <v-flex>
                <h1>{{home.registered_boxes}}</h1>
                <h3>{{$tc('home.registeredBoxes', home.registered_boxes)}}</h3>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        md6
        lg3
      >
        <v-toolbar color="secondary" dark >
          <v-toolbar-side-icon>
            <router-link to="/organization-user-management"><v-icon>group</v-icon></router-link>
          </v-toolbar-side-icon>
          <v-toolbar-title>{{$tc('general.user', 2)}}</v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-container>
            <v-layout row align-center d-inline-flex>
              <v-flex>
                <router-link to="/organization-user-management">
                  <v-btn outline large fab color="green">
                    <v-icon>mdi-clipboard-account</v-icon>
                  </v-btn>
                </router-link>
              </v-flex>
              <v-flex>
                <h1>{{home.registered_users}}</h1>
                <h3>{{$tc('home.registeredUsers', home.registered_users)}}</h3>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <v-toolbar color="secondary" dark >
          <v-toolbar-side-icon><v-icon>mdi-newspaper</v-icon></v-toolbar-side-icon>
          <v-toolbar-title>{{$t('general.news')}}</v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-expansion-panel>
            <v-expansion-panel-content
              v-for="(article, index) in home.news"
              :key="index"
            >
              <div slot="header">{{article.title}}</div>
              <v-card>
                <v-card-text v-html="$sanitize(article.text)">
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { mapGetters } from 'vuex';
import sanitizeHTML from 'sanitize-html';
import Login from '@/components/login/index.vue';

Vue.prototype.$sanitize = sanitizeHTML;

export default {
  components: {
    /* eslint-disable vue/no-unused-components */
    Login,
    /* eslint-enable */
  },
  name: 'home',
  computed: {
    ...mapGetters(['isAuthenticated', 'authStatus']),
    loading() {
      return this.authStatus === 'loading' && !this.isAuthenticated;
    },
  },
  data() {
    return {
      home: {},
      apiUrl: window.api_url,
    };
  },
  mounted() {
    const vm = this;

    axios.get(`${this.apiUrl}api/home`)
      .then((response) => {
        vm.home = response.data.data;
      })
      .catch((error) => {
        vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
      });
  },
};
</script>

<style scoped>
a, a:visited, a:hover { text-decoration: none; color: white; }
</style>
